/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Conflict_HintInputs */

const cs_ebr_conflict_hint = /** @type {(inputs: Ebr_Conflict_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pole upravené ručně po posledním importu. Bez potvrzení zůstane hodnota z CRM.`)
};

const en_ebr_conflict_hint = /** @type {(inputs: Ebr_Conflict_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Field edited manually after the last import. The CRM value stays unless you choose to overwrite.`)
};

/**
* | output |
* | --- |
* | "Field edited manually after the last import. The CRM value stays unless you choose to overwrite." |
*
* @param {Ebr_Conflict_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_conflict_hint = /** @type {((inputs?: Ebr_Conflict_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Conflict_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_conflict_hint(inputs)
	return cs_ebr_conflict_hint(inputs)
});